import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBoxCenter, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

import PageFooter from '@mo-pages/home/footer/PageFooter';

/*
  ECMJ PRG_EXON_02_01 (옥진호)
  CookieGateLayout 페이지 배치를 (컨텐트영역, Footer)로 구성함.
 */
const CookieGateLayout = ({ children }) => {
  return (
    <Layout>
      <FlexBoxCenter width="100%">
        {children}
      </FlexBoxCenter>
      <PageFooter />
    </Layout>
  );
};

CookieGateLayout.propTypes = {
  children: PropTypes.node,
};

const Layout = styled(FlexBoxColumn)`
  width: 360px;
  min-height: calc(var(--vh, 1vh) * 100);
  margin: 0 auto;
`;

export default CookieGateLayout;
